import React from "react";

import styles from "./numericStepper.css";

interface Props {
  max?: number;
  min?: number;
  value?: number;
  placeholder?: string;
  onChange: (value: number | undefined) => void;
}

interface State {
  value: number | undefined;
}

// Allowed keys for input element: left/right arrows, delete, backspace
const safeKeys: Array<number> = [37, 39, 8, 46];

/**
 * Numeric (integer) input component that allows for increasing/decreasing
 * the value with +/- buttons. Provides integer value or undefined to onChange
 * callback.
 **/
export class NumericStepper extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.value !== this.state.value) {
      this.setValue(nextProps.value, false);
    }
  }

  setValue = (value: number | undefined, useCallback: Boolean = true) => {
    if (this.props.min !== undefined && value !== undefined && value < this.props.min) {
      value = this.props.min;
    }
    if (this.props.max !== undefined && value !== undefined && value > this.props.max) {
      value = this.props.max;
    }
    if (value !== this.state.value) {
      this.setState({ value });
      if (useCallback && this.props.onChange) {
        this.props.onChange(value);
      }
    }
  };

  add = () => {
    const value: number = (this.state.value || 0) + 1;
    if (this.props.max === undefined || value <= this.props.max) {
      this.setValue(value);
    }
  };

  subtract = () => {
    const value: number = (this.state.value || 0) - 1;
    if (this.props.min === undefined || value >= this.props.min) {
      this.setValue(value);
    }
  };

  handleChange = (ev: React.FormEvent<HTMLInputElement>) => {
    const value: number = parseInt(ev.currentTarget.value);
    this.setValue(isNaN(value) ? undefined : value);
  };

  /*
   * Handle keypress in input element - reject anything that is not in safeKeys
   * XXX: Will block copy/paste operations
   */
  handleKeyPress = (ev: React.KeyboardEvent<HTMLInputElement>) => {
    if (safeKeys.indexOf(ev.keyCode) === -1 && isNaN(parseInt(ev.key))) {
      ev.preventDefault();
    }
  };

  render() {
    const maxLength = (this.props.max && this.props.max.toString().length) || 2;
    return (
      <div className={styles.inputContainer}>
        <button type="button" className={styles.button} onClick={this.subtract}>
          –
        </button>
        <input
          type="text"
          className={styles.input}
          value={this.state.value === undefined ? "" : this.state.value}
          placeholder={this.props.placeholder}
          onChange={this.handleChange}
          onKeyPress={this.handleKeyPress}
          maxLength={maxLength}
        />
        <button type="button" className={styles.button} onClick={this.add}>
          +
        </button>
      </div>
    );
  }
}
